import {
    DO_AUTOLOGIN,
    SET_USER_AUTHENTICATION,
    SET_USER_CREDITCARDINFO,
    SET_USER_FAVORITE_PRODUCTS,
    SET_USER_FETCHING_CREDITCARDINFO,
    SET_USER_LAST_PURCHASED_PRODUCTS,
    SET_USER_MOST_PURCHASED_PRODUCTS,
    SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES,
} from 'reducers/actions-types';

export default function userReducer(
    state = Object.assign(
        {
            username: '',
            isAuthenticated: false,
            cumulus_connected: false,
            replacementProductsPreferences: null,
            mostPurchasedProducts: [],
            lastPurchasedProducts: [],
            favoriteProducts: [],
            favoriteProductsTotal: 0,
            creditCardInfo: null,
            isFetchingCreditCardInfo: true,
        },
        typeof globals === 'object' ? globals.config.user : {},
    ),
    { type, isAuthenticated, user, products, creditCardInfo, isFetchingCreditCardInfo, replacementProductsPreferences },
) {
    switch (type) {
        case SET_USER_AUTHENTICATION:
            return Object.assign({}, state, {
                isAuthenticated,
            });
        case SET_USER_CREDITCARDINFO:
            return Object.assign({}, state, {
                creditCardInfo,
            });
        case SET_USER_FETCHING_CREDITCARDINFO:
            return Object.assign({}, state, {
                isFetchingCreditCardInfo,
            });
        case SET_USER_REPLACEMENT_PRODUCTS_PREFERENCES:
            return Object.assign({}, state, {
                replacementProductsPreferences,
            });
        case SET_USER_FAVORITE_PRODUCTS:
            return Object.assign({}, state, {
                favoriteProducts: [...products],
                favoriteProductsTotal: products.length,
            });
        case SET_USER_MOST_PURCHASED_PRODUCTS:
            return Object.assign({}, state, {
                mostPurchasedProducts: [...products],
            });
        case SET_USER_LAST_PURCHASED_PRODUCTS:
            return Object.assign({}, state, {
                lastPurchasedProducts: [...products],
            });
        case DO_AUTOLOGIN:
            return Object.assign({}, state, user);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/user/index.js